export const ACCEPTED_COLOR = "#2e7d32";
export const REFUSED_COLOR = "#d32f2f";
export const TOVERIFY_COLOR = "#0288d1";
export const DEFAULT = "#757575";
export const OVERDUE_COLOR = "#e3ae2b";

export const MAX_LENGTH_CHAR = 2000;
export const RELATED_TASKS_LIMIT = 5;
export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB
